import { _ as _sliced_to_array } from "@swc/helpers/_/_sliced_to_array";
import { getDerivedPropsFromErrorProps } from "@faire/web--source/slate/Input/error";
import { useUniqueId } from "@faire/web--source/ui/hooks/useUniqueId";
import { useViewport } from "@faire/web--source/ui/hooks/useViewport";
import * as React from "react";
import { getLabel } from "./utils";
export var useDropdownState = function(param) {
    var id = param.id, inputRef = param.inputRef, filter = param.filter, options = param.options, customOption = param.customOption, useTabletAndAboveDropdownStyle = param.useTabletAndAboveDropdownStyle, error = param.error, ariaLabel = param.ariaLabel, label = param.label;
    var viewport = useViewport();
    var defaultId = useUniqueId("input-");
    var dropdownId = id !== null && id !== void 0 ? id : defaultId;
    var targetRef = React.useRef(null);
    if (inputRef) {
        targetRef = inputRef;
    }
    var refs = React.useRef({});
    var _React_useState = _sliced_to_array(React.useState(false), 2), open = _React_useState[0], setOpen = _React_useState[1];
    var _React_useState1 = _sliced_to_array(React.useState(undefined), 2), searchValue = _React_useState1[0], setSearchValue = _React_useState1[1];
    var _React_useState2 = _sliced_to_array(React.useState(0), 2), highlightIndex = _React_useState2[0], setHighlightIndex = _React_useState2[1];
    var _React_useState3 = _sliced_to_array(React.useState(false), 2), isCustomizingOption = _React_useState3[0], setIsCustomizingOption = _React_useState3[1];
    var filteredOptions = React.useMemo(function() {
        if ((!searchValue || !filter) && customOption === undefined) {
            return options;
        }
        var containsSearch = function(option) {
            var _searchValue_toLowerCase;
            return getLabel(option).toLowerCase().indexOf((_searchValue_toLowerCase = searchValue === null || searchValue === void 0 ? void 0 : searchValue.toLowerCase()) !== null && _searchValue_toLowerCase !== void 0 ? _searchValue_toLowerCase : "") !== -1;
        };
        var filtered = options.filter(containsSearch);
        if (customOption !== undefined && customOption.value !== undefined) {
            var _searchValue_toLowerCase;
            // 2 cases:
            //  1. the search value matches the custom value
            //  2. user hasn't constructed the custom value yet
            // in both cases we want maintain it in the dropdown
            if (customOption.value.indexOf((_searchValue_toLowerCase = searchValue === null || searchValue === void 0 ? void 0 : searchValue.toLowerCase()) !== null && _searchValue_toLowerCase !== void 0 ? _searchValue_toLowerCase : "") !== -1 || !customOption.hasEdited) {
                filtered.push(customOption);
            }
        }
        return filtered;
    }, [
        searchValue,
        filter,
        customOption,
        options
    ]);
    var _getDerivedPropsFromErrorProps = getDerivedPropsFromErrorProps({
        error: error
    }), showErrorState = _getDerivedPropsFromErrorProps.showErrorState, showErrorMessage = _getDerivedPropsFromErrorProps.showErrorMessage, errorMessage = _getDerivedPropsFromErrorProps.errorMessage;
    var labelId = label ? "".concat(dropdownId, "__label") : undefined;
    var ariaProps = React.useMemo(function() {
        if (ariaLabel) {
            return {
                "aria-label": ariaLabel
            };
        }
        if (labelId) {
            return {
                "aria-labelledby": labelId
            };
        }
        return {};
    }, [
        ariaLabel,
        labelId
    ]);
    var showMobileDropdown = viewport.isMobile && !useTabletAndAboveDropdownStyle;
    return {
        dropdownId: dropdownId,
        targetRef: targetRef,
        refs: refs,
        open: open,
        setOpen: setOpen,
        searchValue: searchValue,
        setSearchValue: setSearchValue,
        highlightIndex: highlightIndex,
        setHighlightIndex: setHighlightIndex,
        isCustomizingOption: isCustomizingOption,
        setIsCustomizingOption: setIsCustomizingOption,
        filteredOptions: filteredOptions,
        showErrorState: showErrorState,
        showErrorMessage: showErrorMessage,
        errorMessage: errorMessage,
        ariaProps: ariaProps,
        showMobileDropdown: showMobileDropdown
    };
};
